import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { ActivatedRoute } from "@angular/router";
import { PlayerService } from "../../services/player.service";
import { PlayerModel } from "../../models/player.model";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Meta } from '@angular/platform-browser';
import { AppTitleService } from "../../services/title.service";
import { ProfileService } from "../../services/profile.service";
import { STORE_LINKS } from "../../constants/store-links";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrl: './player.component.scss'
})
export class PlayerComponent implements OnInit, OnDestroy {
  private _playerService: PlayerService = inject(PlayerService);
  private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private _ngxSmartModalService: NgxSmartModalService = inject(NgxSmartModalService);
  private _appTitleService: AppTitleService = inject(AppTitleService);
  private _meta: Meta = inject(Meta);
  private _profileService: ProfileService = inject(ProfileService);
  private _renderer: Renderer2 = inject(Renderer2);
  private _document: Document = inject(DOCUMENT);
  private _languageService: LanguageService = inject(LanguageService);

  player!: PlayerModel;
  donateTo!: {public_id: number, name: string, type: 'team' | 'player'};
  pickupRequestCompleted: boolean = false;
  readonly storeLinks = STORE_LINKS;

  constructor() {}

  get currentLang(): string {
    return this._languageService.currentLang;
  }

  ngOnInit(): void {
    this.getPlayer();
    this.setTheme();
  }

  setTheme(): void {
    this._meta.updateTag({ name: 'theme-color', content: '#2667ff' });
  }

  getPlayer(): void {
    const playerId = this._activatedRoute.snapshot.params['id'];
    this._playerService.getPlayer(playerId).subscribe(result => {
      this.player = result;
      this._profileService.setActiveProfile({ ...this.player, type: 'player' });
      if (this.player?.first_name || this.player?.last_name) {
        const fullName = `${this.player.first_name} ${this.player.last_name}`.trim();
        this._appTitleService.setTitleFromKey('PAGE_TITLE.FORMAT_HP', { title: fullName });
      }
      this.updateSocialMeta(this.player?.banner);
    }, error => {
      console.error('er', error);
    });
  }

  private updateSocialMeta(imageUrl?: string | null): void {
    if (!imageUrl) {
      return;
    }
    const url = imageUrl;
    this._meta.updateTag({ property: 'og:image', content: url });
    this._meta.updateTag({ name: 'twitter:image', content: url });
  }

  openPickupRequestForm(team: boolean = false, player: PlayerModel): void {
    this.donateTo = {
      public_id: team ? player.team.public_id : player.public_id,
      name: team ? player.team.name : `${player.first_name} ${player.last_name}`,
      type: team ? 'team' : 'player'
    }
    this._ngxSmartModalService.getModal('pickupRequestModal').open();
  }

  onPickupRequestSuccess(): void {
    this.pickupRequestCompleted = true;
  }

  ngOnDestroy(): void {
    this._profileService.setActiveProfile(null);
    this._meta.removeTag('name="theme-color"');
  }
}
